module.exports = __webpack_public_path__ + "static/media/createTaskDone.0bdb537a.png";